module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/202001/menu_all-b85925d415d70c727ca236b4823617b6.png";